var patterns = {
    '#': { regex: new RegExp('[0-9]'), pattern: '#' },
    X: { regex: new RegExp('[0-9a-zA-Z]'), pattern: 'X' },
    S: { regex: new RegExp('[a-zA-Z]'), pattern: 'S' },
    A: { regex: new RegExp('[a-zA-Z]'), pattern: 'A', transform: function (v) { return v.toLocaleUpperCase(); } },
    a: { regex: new RegExp('[a-zA-Z]'), pattern: 'a', transform: function (v) { return v.toLocaleLowerCase(); } },
};
export function setupRegex(mask) {
    if (!mask)
        return [];
    var formatedMaskTests = [];
    var used = [];
    var _loop_1 = function (i) {
        var char = mask[i];
        if (patterns[char]) {
            formatedMaskTests.push(patterns[char]);
        }
        else if (char === '|') {
            var idx_1 = mask.indexOf('|', i + 1);
            if (idx_1 > 0) {
                if (!used.some(function (x) { return x === i || x === idx_1; })) {
                    used.push(i, idx_1);
                    var submask = mask.substring(i + 1, idx_1);
                    if (submask[submask.length - 2] === '!') {
                        used.push(idx_1 - 2);
                        i += 2;
                        var willd = submask[submask.length - 1];
                        submask = submask.delete('!');
                        var supatern = '';
                        for (var _i = 0, submask_1 = submask; _i < submask_1.length; _i++) {
                            var subchar = submask_1[_i];
                            if (!supatern.includes(subchar)) {
                                i++;
                                supatern += subchar;
                            }
                        }
                        formatedMaskTests.push({ regex: new RegExp("[".concat(supatern, "]")), multi: true, optional: true, wildcard: willd, pattern: supatern });
                    }
                    else {
                        var supatern = '';
                        for (var _a = 0, submask_2 = submask; _a < submask_2.length; _a++) {
                            var subchar = submask_2[_a];
                            if (!supatern.includes(subchar)) {
                                i++;
                                supatern += subchar;
                            }
                        }
                        formatedMaskTests.push({ regex: new RegExp("[".concat(supatern, "]")), multi: true, pattern: supatern });
                    }
                }
            }
        }
        else if (char === '!' && mask[i + 3] === '!' && patterns[mask[i + 1]]) {
            if (!used.some(function (x) { return x === i || x === (i + 3); })) {
                used.push(i, i + 3);
                var pattern = patterns[mask[i + 1]];
                var optional = mask[i + 2];
                formatedMaskTests.push({ regex: pattern.regex, optional: true, wildcard: optional });
                i += 3;
            }
        }
        else if (!['!', '|'].includes(char)) {
            formatedMaskTests.push({ regex: new RegExp("[".concat(char, "]")), single: true, pattern: char });
        }
        out_i_1 = i;
    };
    var out_i_1;
    for (var i = 0; i < mask.length; i++) {
        _loop_1(i);
        i = out_i_1;
    }
    return formatedMaskTests;
}
export function testRegex(value, formatedMaskTests, complete) {
    if (typeof value !== 'string')
        return { text: value, charsPassed: 0 };
    var charsPassed = 0;
    var okString = '';
    var i = 0;
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var char = value_1[_i];
        if (formatedMaskTests[i]) {
            if (formatedMaskTests[i].regex.test(char)) {
                okString += typeof formatedMaskTests[i].transform === 'function' ? formatedMaskTests[i].transform(char) : char;
            }
            else if (formatedMaskTests[i].multi && formatedMaskTests[i].optional && formatedMaskTests[i + 1] && formatedMaskTests[i + 1].regex.test(char)) {
                okString += "".concat(formatedMaskTests[i].wildcard).concat(typeof formatedMaskTests[i + 1].transform === 'function' ? formatedMaskTests[i + 1].transform(char) : char);
                charsPassed++;
                i++;
            }
            else if (formatedMaskTests[i].single && formatedMaskTests[i + 1] && formatedMaskTests[i + 1].regex.test(char)) {
                okString += "".concat(formatedMaskTests[i].pattern).concat(typeof formatedMaskTests[i + 1].transform === 'function' ? formatedMaskTests[i + 1].transform(char) : char);
                charsPassed++;
                i++;
            }
            else if (!formatedMaskTests[i].optional && !formatedMaskTests[i].single) {
                if (formatedMaskTests[i - 1] && formatedMaskTests[i - 1].optional && formatedMaskTests[i + 1] && formatedMaskTests[i + 1].regex.test(char))
                    okString = okString.insert(i - 1, formatedMaskTests[i - 1].wildcard) + char;
            }
            else if (formatedMaskTests[i].optional && formatedMaskTests[i + 1] && formatedMaskTests[i + 1].regex.test(char)) {
                okString += "".concat(formatedMaskTests[i].wildcard).concat(typeof formatedMaskTests[i + 1].transform === 'function' ? formatedMaskTests[i + 1].transform(char) : char);
                charsPassed++;
                i++;
            }
            else {
                break;
            }
        }
        i++;
    }
    if (complete) {
        if (i < formatedMaskTests.length) {
            for (var x = i; x < formatedMaskTests.length; x++) {
                var test = formatedMaskTests[x];
                if (test.optional) {
                    okString += formatedMaskTests[i].wildcard;
                }
                else {
                    break;
                }
            }
        }
        if (okString.length !== formatedMaskTests.length) {
            okString = '';
            charsPassed = 0;
        }
    }
    return { text: okString, charsPassed: charsPassed };
}
